import { APIFoodImage } from "../services/APIs";
import { foodTypes, roomCleaningstatusData } from "./dataInfo";

export const recordsPerPage = 20;

// Get image URL
export const getFoodImageUrl = (imagePath) => {
    if (!imagePath) return null;
    return `${APIFoodImage}${imagePath}`;
};
export const formatNumberWithComma = (numb) => {
    // Convert to number first
    const num = Number(numb);
    
    // Check if valid number
    if (isNaN(num) || !isFinite(num)) {
        return '0';
    }
    
    // Format the number
    const str = num.toString().split(".");
    str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return str.join(".") +" "+"Sh";
};
export const formatNumberWithComma2 = (numb) => {
    // Convert to number first
    const num = Number(numb);
    
    // Check if valid number
    if (isNaN(num) || !isFinite(num)) {
        return '0';
    }
    
    // Format the number
    const str = num.toString().split(".");
    str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return str.join(".");
};
export const formatCreatedAtDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
        month: 'short',    // "Mar"
        day: '2-digit',   // "02"
        year: 'numeric'    // "2025"
    });
};


export const getNameByIdAndData = (id, Data) => {
    let Id = parseInt(id);
    let nameFound = "Name Not found";
    const record = Data.find((item) => item.id === Id);
    if (record) {
        nameFound = record.name;
    } else {
        return "No Record Found";
    }

    return nameFound;
};

export const roleOptions = [
        { id: 'AD', name: 'Admin' },
        // { id: 'BAD', name: 'Branch Admin' },
        { id: 'ST', name: 'Staff' },
        // { id: 'CA', name: 'Cashier' },
        // { id: 'MA', name: 'Manager' },

    ];


export const getUserRole = (Id) => {
    if (!Id) return "Invalid ID";
    const item = roleOptions.find(item => item.id === Id);
    return item?.name || "Not Found";
};


export const statusData =[
    {id:1,name:"Active"},
    {id:2,name:"Not-Active"},

];

export const getStatusById = (id) => {
    let Id = parseInt(id) ;
    const status = statusData.find(item => item.id === Id);
    return status?.name || "Un-known"
};
export const getroomCleaningStatusById = (id) => {
    let Id = parseInt(id) ;
    const status = roomCleaningstatusData.find(item => item.id === Id);
    return status?.name || "Un-known"
};
export const getFoodTypeById = (Id) => {
    const name = foodTypes.find(item => item.id === Id);
    return name?.name || "Un-known"
};

export const getAllocationStatusNameById = (statusId) => {
    const statusMap = {
        1: 'Active',
        2: 'Completed',
        3: 'Cancelled'
    };
    return statusMap[statusId] || 'Unknown';
};


export const getCategoriesNameById = (id, Data) => {
    let Id = parseInt(id);
    let nameFound = "Name Not found";
    const record = Data.find((item) => item.id === Id);
    if (record) {
        // Rooms, names,booking_source
        nameFound = record.roomtype || record.employee_name || record.booking_type || record.name || record.booking_source || record.floor_name;
    } else {
        return "No Record Found";
    }

    return nameFound;
};



export const getUserDetails = (request) => {
    try {
        const userString = sessionStorage.getItem("userInfo");
        if (!userString) {
            throw new Error("No user details found in session storage");
        }
        const user = JSON.parse(userString);
        if (!user) {
            throw new Error("User details are empty");
        }

        const role = user.role || "";
        const Id = user.id || "";
        const branch_id = user.branch_id || "";
        const counterId = user.counter_id;

        console.log("counterId====>"+counterId)

        switch (request) {
            case "roleId":
                return role;
            case "Id":
                return parseInt(Id);
            case "counterId":
                return parseInt(counterId);
            case "branchId":
                return branch_id;
            default:
                throw new Error("Invalid request parameter");
        }
    } catch (error) {
        console.error("Error in getUserDetails:", error.message);
        return null;
    }
};

// =========== Loans ========================>
export const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });
};

// ================================= Booking Start ======================
// Format booking status
export const getBookingStatus = (status) => {
switch (parseInt(status)) {
    case 0: return 'Cancelled';
    case 1: return 'Active';
    case 2: return 'Checked In';
    case 3: return 'Checked Out';
    default: return 'Unknown';
}
};



// Format payment mode
export const getPaymentMode = (mode) => {
    const paymentModes = {
        'cash': 'Cash Payment',
        'card': 'Card Payment',
        'bank': 'Bank Payment',
        'mobile': 'Mobile Money',
    };
    return paymentModes[mode] || mode;
};

// Format booking type
export const getBookingType = (type) => {
const bookingTypes = {
    1: 'Instant',
    2: 'Allocation',
    3: 'Business Seminar',
    4: 'Wedding',
    5: 'Groups'
};
return bookingTypes[type] || type;
};

// Calculate duration between two dates
export const calculateDuration = (checkIn, checkOut) => {
if (!checkIn || !checkOut) return 0;

const start = new Date(checkIn);
const end = new Date(checkOut);
const diffTime = Math.abs(end - start);
return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};

// Format date range
export const formatDateRange = (checkIn, checkOut) => {
if (!checkIn || !checkOut) return '';

const start = new Date(checkIn).toLocaleDateString();
const end = new Date(checkOut).toLocaleDateString();
const duration = calculateDuration(checkIn, checkOut);

return `${start} to ${end} (${duration} night${duration !== 1 ? 's' : ''})`;
};

// Generate booking number
export const generateBookingNumber = () => {
const date = new Date();
const year = date.getFullYear().toString().slice(-2);
const month = (date.getMonth() + 1).toString().padStart(2, '0');
const day = date.getDate().toString().padStart(2, '0');
const random = Math.floor(Math.random() * 10000).toString().padStart(4, '0');

return `BK${year}${month}${day}${random}`;
};

// Calculate booking charges
export const calculateBookingCharges = (baseCharge, discountRate = 0, taxRate = 0, serviceRate = 0) => {
const discountAmount = baseCharge * (discountRate / 100);
const afterDiscount = baseCharge - discountAmount;
const taxAmount = afterDiscount * (taxRate / 100);
const serviceAmount = afterDiscount * (serviceRate / 100);
const totalAmount = afterDiscount + taxAmount + serviceAmount;

return {
    baseCharge,
    discountRate,
    discountAmount,
    afterDiscount,
    taxRate,
    taxAmount,
    serviceRate,
    serviceAmount,
    totalAmount
};
};

// Validate booking dates
export const validateBookingDates = (checkIn, checkOut) => {
if (!checkIn || !checkOut) {
    return { valid: false, error: 'Both dates are required' };
}

const start = new Date(checkIn);
const end = new Date(checkOut);
const today = new Date();

if (start < today.setHours(0, 0, 0, 0)) {
    return { valid: false, error: 'Check-in date cannot be in the past' };
}

if (end <= start) {
    return { valid: false, error: 'Check-out date must be after check-in date' };
}

const maxDays = 30; // Maximum booking duration
const diffTime = end - start;
const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

if (diffDays > maxDays) {
    return { valid: false, error: `Maximum booking duration is ${maxDays} days` };
}

return { valid: true, duration: diffDays };
};
export const formatCurrency = (amount) => {
  if (!amount && amount !== 0) return '0';
  return new Intl.NumberFormat('en-US').format(amount)+" "+"Sh";
};


// ================================= Booking Start ======================
